module.exports = __webpack_public_path__ + "img/AstroFrens198.d8402f8a.jpg";